import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Row, Col, Button, Form, Card } from 'react-bootstrap';
import Layout from '../../layout/Layout';
import Switch from "react-switch";
import { toast } from 'react-toastify';
import { API } from '../../App';
import Cookies from 'js-cookie'
import Fancybox from '../../Component/FancyBox';

const DashboradWidgetsEdit = () => {

    const navigate = useNavigate()
    const { id } = useParams()
    const [validate, setValidate] = useState(false)
    const [cat, setCategory] = useState([])
    const [themes, setThemes] = useState([])
    const [variants, setVariants] = useState([])
    const [removedVariantIds, setRemovedVariantIds] = useState([])
    const [loading, Setloading] = useState(false)
    const [status, setstatus] = useState(true)
    const [is_premium, setis_premium] = useState(true)

    const [user, setuser] = useState({
        rank: "",
        category_id: "",
        dashboard_theme_id: "",
        widget_name: "",
    })

    const addVariant = () => {
        setVariants([...variants, {
            widget_type: "", preview_image: null, widget_image: null, clock_image: null,
            quote: "", text_color: "", font_name: "", alignment: "", sort_order: "", status: true
        }])
    }
    const removeVariant = (i) => {
        const d = [...variants]
        const [removed] = d.splice(i, 1)
        if (removed && removed._id) setRemovedVariantIds([...removedVariantIds, removed._id])
        setVariants(d)
    }
    const variantChange = (e, i, isFile) => {
        const d = [...variants]
        d[i][e.target.name] = isFile ? e.target.files[0] : e.target.value
        setVariants(d)
    }

    const lodadata = async () => {
        const token = Cookies.get('jwt')
        const catRes = await API.post("/widget_category")
        setCategory(catRes.data.data[0].get_SubCategory)

        const themeRes = await API.post("/dashboardThemesData", {}, { headers: { "authorization": `Bearer ${token}` } })
        setThemes(themeRes.data.data || [])

        const res = await API.post(`/dashboardWidgets/${id}`, {}, { headers: { "authorization": `Bearer ${token}` } })
        const data = res.data.data[0]
        setuser({
            rank: data.rank,
            category_id: data.category_id?._id || "",
            dashboard_theme_id: data.dashboard_theme_id?._id || data.dashboard_theme_id || "",
            widget_name: data.widget_name || "",
        })
        setstatus(data.status === true)
        setis_premium(data.is_premium === true)
        setVariants(
            (data.variants || []).slice().sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0))
        )
    }

    const onInputchange = (e) => {
        setuser({ ...user, [e.target.name]: e.target.value })
    }

    useEffect(() => {
        lodadata()
    }, [])

    const handdelsubmission = async () => {
        if (user.rank === "" || !user.rank) {
            setValidate(true)
        }
        else if (!user.dashboard_theme_id) {
            setValidate(true)
        }
        else if (!user.widget_name) {
            setValidate(true)
        }
        else if (user.category_id === "" || !user.category_id) {
            setValidate(true)
        }
        else if (variants.length < 1) {
            setValidate(true)
            toast.error("At least one Widget Size (variant) is required", { position: "bottom-right", autoClose: 2000 })
        }
        else {
            // new variants must have required fields; existing ones already have images
            for (const v of variants) {
                if (!v._id && (!v.preview_image || !v.widget_image)) {
                    setValidate(true)
                    toast.error("Please fill all required Widget Size fields (Size Type, Preview Image, Widget Image)", { position: "bottom-right", autoClose: 2000 })
                    return
                }
            }

            Setloading(true)
            const token = Cookies.get('jwt')
            const formdata = new FormData()
            formdata.append("rank", user.rank)
            formdata.append("category_id", user.category_id)
            formdata.append("dashboard_theme_id", user.dashboard_theme_id)
            formdata.append("widget_name", user.widget_name)
            formdata.append("status", status)
            formdata.append("is_premium", is_premium)

            const res = await API.post(`/dashboardWidgetsUpd/${id}`, formdata, { headers: { "authorization": `Bearer ${token}` } })
            if (res.data.status === true) {
                let variantError = null

                // delete removed variants
                for (const rid of removedVariantIds) {
                    await API.post(`/widgetVariantsDel/${rid}`, {}, { headers: { authorization: `Bearer ${token}` } })
                }

                // create / update each variant
                for (const v of variants) {
                    const vfd = new FormData()
                    vfd.append("widget_id", id)
                    vfd.append("widget_type", v.widget_type)
                    if (v.preview_image instanceof File) vfd.append("preview_image", v.preview_image)
                    if (v.widget_image instanceof File) vfd.append("widget_image", v.widget_image)
                    if (v.clock_image instanceof File) vfd.append("clock_image", v.clock_image)
                    vfd.append("quote", v.quote || "")
                    vfd.append("text_color", v.text_color || "")
                    vfd.append("font_name", v.font_name || "")
                    vfd.append("alignment", v.alignment || "")
                    vfd.append("sort_order", v.sort_order || "")
                    vfd.append("status", v.status)

                    const url = v._id ? `/widgetVariantsUpdate/${v._id}` : "/widgetVariants"
                    const vres = await API.post(url, vfd, { headers: { authorization: `Bearer ${token}` } })
                    if (vres.data.status !== true && vres.data.response_code !== 1) {
                        variantError = vres.data.response_message || "Variant save failed"
                        break
                    }
                }

                Setloading(false)
                if (variantError) {
                    toast.error("Widget saved but a size failed: " + variantError, { position: "bottom-right", autoClose: 3000 })
                } else {
                    toast.success("Data Updated Sucessfully", { position: "bottom-right", autoClose: 500 })
                    navigate("/dashbordwidgets")
                }
            } else {
                Setloading(false)
                toast.error(res.data.response_message || "Something went wrong!")
            }
        }
    }

    return (
        <Layout sidebar={true}>
            <div className="page-heading">
                <h3 className="my-1"> Edit Dashboard Widgets</h3>
            </div>
            <div className="page-content">
                <Form noValidate validated={validate}>
                    <Row>
                        <Col xs={12}>
                            <Card className="mb-4">
                                <Card.Body>
                                    <Row>
                                        <Col lg={3} sm={12}>
                                            <Form.Group >
                                                <Form.Label htmlFor="m_cate" >New Index</Form.Label>
                                                <Form.Control type="number" id='cate-img' className="my-2" name='rank' placeholder='Enter Index' value={user.rank} onChange={onInputchange} required />
                                                <Form.Control.Feedback type="invalid">
                                                    Enter Index
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={3} xs={12}>
                                            <Form.Label htmlFor='m_cate'>Category Id</Form.Label>
                                            <Form.Select className='my-2' name='category_id' value={user.category_id} onChange={onInputchange} required>
                                                <option value="">Select Category Id</option>
                                                {
                                                    cat.map((val, id) => {
                                                        return (
                                                            <option key={id} value={val._id} >{val.name}</option>
                                                        )
                                                    })
                                                }
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">
                                                Select Category
                                            </Form.Control.Feedback>
                                        </Col>
                                        <Col lg={3} xs={12}>
                                            <Form.Label htmlFor='dashboard_theme_id'>Theme</Form.Label>
                                            <Form.Select className='my-2' name='dashboard_theme_id' value={user.dashboard_theme_id} onChange={onInputchange}>
                                                <option value="">Select Theme</option>
                                                {
                                                    themes.map((val, id) => {
                                                        return (
                                                            <option key={id} value={val._id} >{val.name}</option>
                                                        )
                                                    })
                                                }
                                            </Form.Select>
                                        </Col>
                                        <Col lg={3} sm={12}>
                                            <Form.Group>
                                                <Form.Label htmlFor="widget_name">Widget Name</Form.Label>
                                                <Form.Control type="text" id='widget_name' name='widget_name' className="my-2" value={user.widget_name} placeholder='e.g. Minimal Clock' onChange={onInputchange} />
                                            </Form.Group>
                                        </Col>
                                        <Col lg={3} sm="12">
                                            <Form.Label htmlFor="media_type" className='d-block mb-2'>Is Premium</Form.Label>
                                            <Switch
                                                onChange={(checked) => setis_premium(checked === true)}
                                                checked={is_premium === true ? true : false}
                                                offColor="#C8C8C8"
                                                onColor="#0093ed"
                                                height={30}
                                                width={70}
                                                className="react-switch"
                                                uncheckedIcon={
                                                    <div className='react-switch-off'>NO</div>
                                                }
                                                checkedIcon={
                                                    <div className='react-switch-on'>YES</div>
                                                }
                                            />
                                        </Col>
                                        <Col lg={3} sm="12">
                                            <Form.Label htmlFor="media_type" className='d-block mb-2'>Status</Form.Label>
                                            <Switch
                                                onChange={(checked) => setstatus(checked === true)}
                                                checked={status === true ? true : false}
                                                offColor="#C8C8C8"
                                                onColor="#0093ed"
                                                height={30}
                                                width={70}
                                                className="react-switch"
                                                uncheckedIcon={
                                                    <div className='react-switch-off'>OFF</div>
                                                }
                                                checkedIcon={
                                                    <div className='react-switch-on'>ON</div>
                                                }
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-4">
                                        <Col xs={12} className="d-flex justify-content-between align-items-center">
                                            <h5 className="mb-0">Widget Sizes (Variants)</h5>
                                            <Button variant="primary" size="sm" onClick={addVariant} disabled={variants.length >= 3}>Add Size</Button>
                                        </Col>
                                    </Row>
                                    {
                                        variants.map((v, ind) => (
                                            <div key={v._id || ind} className="border rounded-3 my-2 p-3">
                                              <Row>
                                                <Col lg={3} sm={12}>
                                                    <Form.Label>Size Type</Form.Label>
                                                    <Form.Select className="my-2" name="widget_type" value={v.widget_type} onChange={(e) => variantChange(e, ind, false)}>
                                                        <option value="">Select Size</option>
                                                        <option value="small">Small</option>
                                                        <option value="medium">Medium</option>
                                                        <option value="large">Large</option>
                                                    </Form.Select>
                                                </Col>
                                                <Col lg={3} sm={12}>
                                                    <Form.Label>Preview Image</Form.Label>
                                                    <Form.Control type="file" accept="image/*" className="my-2" name="preview_image" onChange={(e) => variantChange(e, ind, true)} />
                                                    {v.preview_image && !(v.preview_image instanceof File) &&
                                                        <Fancybox>
                                                            <a data-fancybox="gallery" href={v.preview_image}>
                                                                <img src={v.preview_image} className='hv-40 bg-light rounded-3 w-100' alt='preview' />
                                                            </a>
                                                        </Fancybox>}
                                                </Col>
                                                <Col lg={3} sm={12}>
                                                    <Form.Label>Widget Image</Form.Label>
                                                    <Form.Control type="file" accept="image/*" className="my-2" name="widget_image" onChange={(e) => variantChange(e, ind, true)} />
                                                    {v.widget_image && !(v.widget_image instanceof File) &&
                                                        <Fancybox>
                                                            <a data-fancybox="gallery" href={v.widget_image}>
                                                                <img src={v.widget_image} className='hv-40 bg-light rounded-3 w-100' alt='widget' />
                                                            </a>
                                                        </Fancybox>}
                                                </Col>
                                                <Col lg={3} sm={12}>
                                                    <Form.Label>Clock Image</Form.Label>
                                                    <Form.Control type="file" accept="image/*" className="my-2" name="clock_image" onChange={(e) => variantChange(e, ind, true)} />
                                                    {v.clock_image && !(v.clock_image instanceof File) &&
                                                        <Fancybox>
                                                            <a data-fancybox="gallery" href={v.clock_image}>
                                                                <img src={v.clock_image} className='hv-40 bg-light rounded-3 w-100' alt='clock' />
                                                            </a>
                                                        </Fancybox>}
                                                </Col>
                                                <Col lg={3} sm={12}>
                                                    <Form.Label>Text Color</Form.Label>
                                                    <Form.Control type="text" className="my-2" name="text_color" value={v.text_color || ""} placeholder="#FFFFFF" onChange={(e) => variantChange(e, ind, false)} />
                                                </Col>
                                                <Col lg={3} sm={12}>
                                                    <Form.Label>Font Name</Form.Label>
                                                    <Form.Control type="text" className="my-2" name="font_name" value={v.font_name || ""} placeholder="e.g. BLOODY" onChange={(e) => variantChange(e, ind, false)} />
                                                </Col>
                                                <Col lg={2} sm={12}>
                                                    <Form.Label>Alignment</Form.Label>
                                                    <Form.Select className="my-2" name="alignment" value={v.alignment || ""} onChange={(e) => variantChange(e, ind, false)}>
                                                        <option value="">Select</option>
                                                        <option value="left">Left</option>
                                                        <option value="center">Center</option>
                                                        <option value="right">Right</option>
                                                    </Form.Select>
                                                </Col>
                                                <Col lg={2} sm={12}>
                                                    <Form.Label>Quote</Form.Label>
                                                    <Form.Control type="text" className="my-2" name="quote" value={v.quote || ""} onChange={(e) => variantChange(e, ind, false)} />
                                                </Col>
                                                <Col lg={1} sm={12}>
                                                    <Form.Label className="d-block mb-2">Status</Form.Label>
                                                    <Switch
                                                        onChange={(checked) => variantChange({ target: { name: 'status', value: checked } }, ind, false)}
                                                        checked={v.status === true}
                                                        offColor="#C8C8C8"
                                                        onColor="#0093ed"
                                                        height={30}
                                                        width={70}
                                                        className="react-switch"
                                                        uncheckedIcon={<div className='react-switch-off'>OFF</div>}
                                                        checkedIcon={<div className='react-switch-on'>ON</div>}
                                                    />
                                                </Col>
                                                <Col lg={1} sm={12} className="align-self-end my-3">
                                                    <Button variant="danger" size="sm" className="btn-icon" onClick={() => removeVariant(ind)}><i class='bx bx-x'></i></Button>
                                                </Col>
                                              </Row>
                                            </div>
                                        ))
                                    }
                                </Card.Body>
                                <Card.Footer className="text-end">
                                    <Button variant="primary" className="me-3" onClick={handdelsubmission} disabled={loading}>Save</Button>
                                    <Link to="/dashbordwidgets">
                                        <Button variant="secondary">Cancle</Button>
                                    </Link>
                                </Card.Footer>
                            </Card>
                        </Col>
                    </Row>
                </Form>
            </div>
        </Layout>
    )
}

export default DashboradWidgetsEdit
